// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"customer_promotion_manager__194NP","card":"customer_card__3GwDk"};